export default {
    onboarding: {
        actions: {
            mainBlue: 'Iniziare'
        }
    },
    details: {
        aboutProperty: 'Informazioni aggiuntive',
        title: 'Si prega di confermare le seguenti informazioni:',
        errorMsgInputTxt: 'Campo obbligatorio',
        errorMsgGeneral: 'Si prega di controllare il modulo prima di continuare',
        errorImages: 'Si prega di aggiungere foto prima di continuare',
        address: {
            literal: 'Indirizzo',
            placeholder: 'Inserisci una posizione'
        },
        zipCode: {
            literal: 'Codice postale'
        },
        propertyType: {
            literal: 'Tipo di proprietà',
            options: {
                appartment: 'Flat',
                maison: 'Casa',
                local_commercial: 'Locali commerciali'
            }
        },
        residentType: {
            literal: 'Tipo di residente',
            options: {
                propietarie: 'Proprietario',
                locataire: 'Inquilino',
                propietarie_non_occupant: 'Proprietario Non Occupante'
            }
        },
        moreThanTwoYears: {
            literal: "Età dell'edificio",
            options: {
                more: 'Più di 2 anni',
                less: 'Meno di 2 anni'
            }
        },
        observations: {
            literal: 'Commenti'
        },
        map: {
            empty: {
                title: 'Nessun indirizzo',
                text: 'Inserisci un indirizzo valido'
            }
        },
        textArea: {
            placeHolder: 'Lunghezza del testo limitata a un massimo di 255 caratteri'
        }
    },
    closing: {
        actions: {
            mobilierButton: 'Continua con i danni ai mobili'
        }
    },
    compensationType: {
        title: 'Gestire un sinistro non è mai stato così facile',
        subtitle: 'A proposito dei danni alla tua propriet� ',
        text: 'Per fare ciò, proponiamo tre possibili soluzioni:',
        recommended: 'La nostra raccomandazione!',
        amount: 'Importo rimborsato:',
        e2eCompensations: {
            gagDetail: {
                title: 'Vuoi farlo da solo?',
                text: 'Sei un tuttofare. Copriamo il costo dei materiali, i piccoli costi degli utensili e ti compensiamo per il tempo speso.',
                link: 'Valutiamo insieme le tue esigenze'
            },
            billma: {
                title: 'Compensazione su preventivo',
                text: 'Allega foto e fatture della merce danneggiata al tuo reso. La nostra unità tecnica lo convaliderà.',
                link: 'Carica il tuo preventivo'
            },
            renDetail: {
                title: 'Servizio di riparazione',
                text: 'Utilizza il nostro servizio di riparazione. Facci sapere quando sei disponibile per un appuntamento.',
                link: 'Fissa un appuntamento'
            }
        }
    },
    compensationMobilier: {
        title: 'Per quanto riguarda i tuoi danni alla proprietà',
        subtitle: 'Importo del risarcimento',
        total: 'Total:',
        totalAmount: 'Compenso totale',
        actions: {
            primary: 'Sì, accetto il compenso proposto',
            secondary: 'Voglio parlare con un consulente'
        }
    }
}